import React from "react";
import { makeObservable, observable, action } from "mobx";

class TemplatesDetailStore {
  constructor() {
    makeObservable(this, {
      loadData: observable,
      moderation: observable,
      isLoading: observable,
      moderationStatus: observable,
      mixabilityStatus: observable,
      referenceStatus: observable,
      assetStatus: observable,
      entertainmentStatus: observable,
      recommendedStatus: observable,
      gachaStatus: observable,
      gameStatus: observable,
      languageStatus: observable,
      regionStatus: observable,
      extraDescStatus: observable,
      emptyRegionCheck: observable,
    });
  }

  loadData = false;
  moderation = false;
  isLoading = true;
  moderationStatus = false;
  mixabilityStatus = false;
  referenceStatus = false;
  assetStatus = false;
  entertainmentStatus = false;
  recommendedStatus = false;
  gachaStatus = false;
  gameStatus = false;
  languageStatus = false;
  regionStatus = false;
  extraDescStatus = false;
  emptyRegionCheck = false;

  setModeration = action((moderation: boolean) => {
    this.moderation = moderation;
  });

  setLoading = action((isLoading: boolean) => {
    this.isLoading = isLoading;
  });

  setLoadData = action((loadData: boolean) => {
    this.loadData = loadData;
  });

  setModerStatus = action((moderationStatus: boolean) => {
    this.moderationStatus = moderationStatus;
  });

  setMixabilityStatus = action((mixabilityStatus: boolean) => {
    this.mixabilityStatus = mixabilityStatus;
  });

  setRefernceStatus = action((referenceStatus: boolean) => {
    this.referenceStatus = referenceStatus;
  });

  setAssetStatus = action((assetStatus: boolean) => {
    this.assetStatus = assetStatus;
  });

  setEntertainmentStatus = action((entertainmentStatus: boolean) => {
    this.entertainmentStatus = entertainmentStatus;
  });

  setRecommendedStatus = action((recommendedStatus: boolean) => {
    this.recommendedStatus = recommendedStatus;
  });

  setGachaStatus = action((gachaStatus: boolean) => {
    this.gachaStatus = gachaStatus;
  });

  setGameStatus = action((gameStatus: boolean) => {
    this.gameStatus = gameStatus;
  });

  setLanguageStatus = action((languageStatus: boolean) => {
    this.languageStatus = languageStatus;
  });

  setRegionStatus = action((regionStatus: boolean) => {
    this.regionStatus = regionStatus;
  });

  setExtraDescStatus = action((extraDescStatus: boolean) => {
    this.extraDescStatus = extraDescStatus;
  });

  setEmptyRegionCheck = action((emptyRegionCheck: boolean) => {
    this.emptyRegionCheck = emptyRegionCheck;
  });
}

export default TemplatesDetailStore;
